import Icon from "../icon/icon";
import React from "react";
import LoginUrlService from "../../utilities/loginUrlService";

export interface IUserGreetingProps {
  className?: string;
  displayIcon?: boolean;
  isLoggedIn: boolean;
  isCookied: boolean;
  firstName: string;
  loginHref: string;
  registerHref: string;
  displayRegisterLink: boolean;
}

function UserGreeting(props: IUserGreetingProps) {
  const loginUrl = LoginUrlService.getPreLoadedLoginUrl();
  const registrationUrl = LoginUrlService.getPreLoadedRegistrationUrl();

  return (
    <div className={`user-greeting ${props.className}`}>
      {props.displayIcon && (
        <Icon className="align-middle user-icon">account_circle</Icon>
      )}
      Hi
      {(props.isLoggedIn || props.isCookied) && (
        <>
          {" "}
          <span className="first-name-greeting"> {props.firstName.split(" ")[0]}</span> 
        </>
      )}
      {props.isCookied && (
        <span>
          , <a href={loginUrl}>Sign In</a>
        </span>
      )}
      {!props.isCookied && !props.isLoggedIn && (
        <span>
          , <a href={loginUrl}>Sign In</a>
          {props.displayRegisterLink && (
            <>
              {" "}
              or <a href={registrationUrl}>Register</a>
            </>
          )}
        </span>
      )}
    </div>
  );
}

export default UserGreeting;
